module.exports = __webpack_public_path__ + "img/bus-icon.e6cbbd88.png";